<template>
  <div class="container">
    <el-row>
      <!--目录-->
      <el-col :span="3">
        <zg-catalog title="原始记录（直观）" :route-name="'site_'+this.site_type+'_list'"></zg-catalog>
      </el-col>
      <!--原始记录操作-->
      <el-col :span="21">
        <Toolbar
            :inspectStatus="inspect_status"
            :buttons="buttons"
            :currentRoute="currentRoute"
            :projectId="project_id"
            :siteId="site_id"
            :toolbarSelects="toolbarSelects"
            @selectCommand="handleSelectCommand"
            :showPagination="showPagination"
            :currentPage="currentPage"
            @currentChange="fetchMaxPage"
            :totalItems="totalItems"
            :pageSize="1"
            :siteType="site_type"
        />
        <hr>
        <!--原始记录表单-->
        <el-form style="margin: 0;margin-top:10px;" ref="form" :model="form" :inline="true" size="mini">
          <table>
            <tr>
              <td>项目编号</td>
              <td>检测内容</td>
              <td>检测标准（规范）</td>
              <td>重要程度</td>
              <td colspan="4">检测结果/数据</td>
            </tr>
            <template>
              <tr>
                <td>{{ items.item1_code }}</td>
                <td colspan="3">{{ items.item1_content }}</td>
                <template v-for="i of 4">
                  <td :key="i">
                    <el-input style="width:100%" v-model="form['wz'+i]" size="max"></el-input>
                  </td>
                </template>
              </tr>
              <template v-for="item2 in items.item2s">
                <tr :key="item2.item2_code">
                  <td>{{ item2.item2_code }}</td>
                  <td>{{ item2.item2_type }}</td>
                  <td>{{ item2.item2_content }}</td>
                  <td>{{ item2.item2_level }}</td>
                  <template v-for="index of 4">
                    <td :key=index>
                      <div>
                        <el-select v-model="form['wz'+index+item2.item2_code+'jg']" clearable
                                   placeholder="请选择结论"
                                   style="width:100%">
                          <el-option label="符合要求" value="符合要求"></el-option>
                          <el-option label="不符合要求" value="不符合要求"></el-option>
                          <el-option label="无此项" value="无此项"></el-option>
                        </el-seLect>
                      </div>
                      <div>
                        <el-select v-model="form['wz'+index+item2.item2_code+'sj']" clearable
                                   placeholder="请选择隐患"
                                   style="width:100%">
                          <el-option v-for="(option,i) in item2.trouble_options" :key="i" :label="option"
                                     :value="option"></el-option>
                        </el-select>
                      </div>
                    </td>
                  </template>
                </tr>
              </template>
            </template>
          </table>
        </el-form>
        <!--图片-->
        <el-button v-if="inspect_status" size="mini" type="primary" @click="handleAddImage"
                   style="margin-top:20px;margin-bottom: 10px">
          新增图片
        </el-button>
        <span style="margin-left: 10px;color:red">请先保存上面的检测项，再新增图片</span>
        <!---图片列表-->
        <el-table :data="tableData" :header-cell-style="{background:'#B4DDD1',color:'#555'}"
                  style="width: 100%" @dblclick="handleEditImage">
          <el-table-column prop="location" label="位置"></el-table-column>
          <el-table-column prop="item2_code" label="项目编号"></el-table-column>
          <el-table-column prop="url" label="图片">
            <template v-slot="scope">
              <img :src="scope.row.url" width="70" height="70" @click="previewPic(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="pic_desc" label="描述"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button v-if="inspect_status" size="mini" plain type="primary" @click="handleEditImage(scope.row)">
                编辑
              </el-button>
              <el-button v-if="inspect_status" size="mini" plain type="danger" @click="handleDelImage(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--图片列表分页-->
        <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
                       :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
      </el-col>
    </el-row>
    <!--新增图片-->
    <el-dialog title="新增图片" :visible.sync="addImageModel.show" width="800px">
      <el-form :model="addImageModel">
        <el-form-item>
          <el-col :span="11">
            <el-select v-model="addImageModel.location" clearable placeholder="请选择位置">
              <el-option v-for="(item,i) in wzOpts"
                         :key="i"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="11">
            <el-select v-model="addImageModel.item2_code" clearable placeholder="请选择项目编号" style="width: 100%">
              <el-option v-for="item in items.item2s" :key="item.item2_code" :label="item.item2_code"
                         :value="item.item2_code"/>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="11">
            <el-upload action="https://dq-back.wzfire.com/upload_file"
                       name="upload_file"
                       ref="upload"
                       list-type="picture-card"
                       :on-preview="handlePictureCardPreview"
                       :on-remove="handleRemove"
                       :on-success="uploadSuccess"
                       :headers="headers"
                       accept=".jpeg,.jpg,.png"
                       :data="uploadData"
                       :limit="1"
                       :before-upload="beforeUpload"
                       :on-exceed="onExceed"
                       :on-change="handleEditChange"
                       :class="{hide:hideUpload}"
            >
              点击上传图片1
            </el-upload>
          </el-col>
          <el-col :span="11">
            <el-input v-model="addImageModel.image_desc" placeholder="请在此添加图片1的描述"
                      style="margin-top:50px"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onAddImage">提交</el-button>
          <el-button type="info" @click="onAddImageClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--预览图片-->
    <el-dialog :visible.sync="pictureModel.dialogVisible" :modal="false" v-model="pictureModel" title="图片预览"
               width="50%">
      <img :src="pictureModel.previewpic" alt="" width="100%"/>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="pictureModel.dialogVisible = false">确定</el-button>
          </span>
    </el-dialog>
    <!--编辑图片描述-->
    <el-dialog :visible.sync="editPictureModel.show" title="编辑图片描述" width="50%">
      <el-form v-model="editPictureModel">
        <el-form-item label="描述">
          <el-input v-model="editPictureModel.pic_desc"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onEditImage">提交</el-button>
          <el-button type="info" @click="handleCloseEditImage">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--预览图片-->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import site_czw_list from "@/modules/project/base/detail/site_czw_list.vue";
import RouteSelector from "@/components/RouteSelector.vue";
import Toolbar from "@/components/Toolbar.vue";
import _ from 'lodash';


let token = Vue.$Config.userinfo.token
export default {
  components: {Toolbar, RouteSelector},
  data() {
    return {
      currentRoute: 'record_zg_index',
      buttons: [
        {text: '提交', type: 'success', onClick: this.handleSubmit},
        {text: '新增一页', type: 'primary', onClick: this.handleNewPage},
        {text: '删除当前页', type: 'danger', onClick: this.handleDel},
      ],
      headers: {Authorization: token},
      hideUpload: false,
      uploadData: {
        project_id: '',
        site_id: '',
        site_type: '',
        zg_type: '',
      },
      project_id: '',
      site_id: '',
      site_type: '',
      zg_type: '',
      inspect_status: false,
      showPagination: true,
      pages: [],
      currentPage: 1,
      totalItems: 1,
      maxPage: 0,
      currentOpt: '',
      toolbarSelects: [
        {label: '请选择快捷操作', value: ''},
        {label: '全部符合要求', value: '全部 符合要求'},
        {label: '全部不符合要求', value: '全部 不符合要求'},
        {label: '位置1符合要求', value: 'wz1 符合要求'},
        {label: '位置1不符合要求', value: 'wz1 不符合要求'},
        {label: '位置2符合要求', value: 'wz2 符合要求'},
        {label: '位置2不符合要求', value: 'wz2 不符合要求'},
        {label: '位置3符合要求', value: 'wz3 符合要求'},
        {label: '位置3不符合要求', value: 'wz3 不符合要求'},
        {label: '位置4符合要求', value: 'wz4 符合要求'},
        {label: '位置4不符合要求', value: 'wz4 不符合要求'},
      ],
      items: [],
      form: {},
      //图片
      current_page: 1,
      pagination: {current_page: 1, total: 1, per_page: 10},
      tableData: [],
      addImageModel: {
        show: false,
        location: '',
        item2_code: '',
        image_id: '',
        image_desc: ''
      },
      wzOpts: [],
      isLoading: false,
      item2CodeOpts: [],
      dialogVisible: false,
      dialogImageUrl: '',
      pictureModel: {
        dialogVisible: false,
        previewpic: '',
      },
      editPictureModel: {
        show: false,
        id: '',
        pic_desc: ''
      },
    }
  },
  methods: {
    init() {
      this.project_id = this.$route.params.project_id
      this.site_id = this.$route.params.site_id
      this.site_type = this.$route.params.site_type
      this.zg_type = this.$route.params.zg_type
      this.uploadData.zg_type = this.$route.params.zg_type
      this.uploadData.project_id = this.$route.params.project_id
      this.uploadData.site_id = this.$route.params.site_id
      this.uploadData.site_type = this.$route.params.site_type
      this.setButtonStatus()
      this.getZgItems()
      this.fetchMaxPage();
    },

    //新增图片
    handleAddImage() {
      this.addImageModel.show = true;
    },
    async onAddImage() {
      try {
        let params = this.addImageModel
        delete params.show
        params.project_id = this.project_id
        params.site_id = this.site_id
        params.site_type = this.site_type
        params.current_page = this.currentPage
        params.zg_type = this.zg_type
        await this.$Api.post('add_zg_image', params)
        this.onAddImageClose()
        this.$message.success('新增图片成功')
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onAddImageClose() {
      this.addImageModel.show = false
      this.addImageModel.location = ''
      this.addImageModel.item2_code = ''
      this.addImageModel.image_id = ''
      this.addImageModel.image_desc = ''
      location.reload()
    },
    //编辑图片
    handleEditImage(row) {
      this.editPictureModel.show = true;
      this.editPictureModel.id = row.id
      this.editPictureModel.pic_desc = row.pic_desc
    },
    async onEditImage() {
      try {
        await this.$Api.post('edit_zg_image', {id: this.editPictureModel.id, pic_desc: this.editPictureModel.pic_desc})
        await this.getList()
        this.$message.success("修改成功")
        this.handleCloseEditImage()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    handleCloseEditImage() {
      this.editPictureModel.show = false
      this.editPictureModel.pic_desc = ''
      this.editPictureModel.id = ''
    },
    //删除图片
    async handleDelImage(row) {
      try {
        await this.$Api.post('del_zg_image', {id: row.id})
        await this.getList()
        this.$message.success("删除成功")
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //预览图片
    previewPic(row) {
      this.pictureModel.previewpic = row.url
      this.pictureModel.dialogVisible = true
    },
    //上传图片
    onExceed(files, fileList) {
      this.$message.error("只能上传一个图片")
    },
    beforeUpload(file) {
      if (this.addImageModel.location.length === 0 || this.addImageModel.item2_code.length === 0) {
        this.$message.error("请先选择位置和项目编号")
        return false
      }
    },
    uploadSuccess(response, file, fileList) {
      this.addImageModel.image_id = response.data.file_id
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      this.hideUpload = fileList.length >= 1
      try {
        this.$Api.post('del_upload_file', {id: file.response.data.file_id})
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    handleEditChange(file, fileList) {
      this.hideUpload = fileList.length >= 1
    },
    //图片列表
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    //获取检测项
    async getZgItems() {
      try {
        let res = await this.$Api.post('get_zg_items', {zg_type: this.zg_type, site_type: this.site_type})
        if (res) {
          let allItem2Code = []; // 全部检查项
          this.items = res;
          if (res.item2s && res.item2s.length) {
            res.item2s.map(v => {
              if (v.item2_code) {
                allItem2Code.push(v.item2_code);
              }
              return v;
            });
          }
          this.form = {}
          for (let wz of ['wz1', 'wz2', 'wz3', 'wz4']) {
            this.$set(this.form, wz, '')
            for (let item2_code of allItem2Code) {
              let jg_key = wz + item2_code + 'jg'
              let sj_key = wz + item2_code + 'sj'
              this.$set(this.form, jg_key, '')
              this.$set(this.form, sj_key, '')
            }
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //新增一页
    handleNewPage: _.debounce(function () {
      let tempForm = {...this.form} // 创建form的深拷贝
      delete tempForm.id
      Object.keys(tempForm).forEach(key => {
        tempForm[key] = ''
      })
      this.form = tempForm // 一次性赋值回form
    }, 2000, {leading: true, trailing: false}),
    //获取最大页码
    async fetchMaxPage(newPage) {
      let res = await this.$Api.post('get_max_page', {
        project_id: this.project_id,
        site_id: this.site_id,
        zg_type: this.zg_type,
        site_type: this.site_type
      })
      if (!newPage) {
        newPage = 1
      }
      this.currentPage = newPage
      this.totalItems = res.max_page
      await this.getRecord(this.currentPage)
    },
    //获取原始记录
    async getRecord(current_page) {
      try {
        let params = {
          current_page: current_page,
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
          zg_type: this.zg_type,
        }
        let res = await this.$Api.post('get_record_zg', params)
        if (res) {
          this.form = res
          await this.getList()
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //删除原始记录
    async handleDel() {
      this.$confirm("确认删除?", "将删除与该页相关的所有检测项目以及图片", {
        confirmButtonClass: '确认',
        cancelButtonClass: '取消',
        type: 'warning'
      }).then(
          async () => {
            try {
              let params = {
                id: this.form.id,
                project_id: this.project_id,
                site_id: this.site_id,
                current_page: this.currentPage,
                zg_type: this.zg_type,
                site_type: this.site_type
              }
              await this.$Api.post('del_record_zg', params)
              this.$message.success('删除成功')
            } catch (e) {
              this.$message.error(e.errormsg)
            }
          }
      )
    },
    //新增或者编辑
    handleSubmit() {
      for (let key in this.form) {
        if (key.indexOf('01') !== -1 && key.indexOf('jg') !== -1) {
          if (!this.form[key.slice(0, 3)]) continue //位置值为空跳过
          if (!this.form[key]) {
            this.$notify({
              title: '未填写',
              message: '位置:' + this.form[key.slice(0, 3)] + '，项目编号：' + key.slice(3, 7) + '未判断',
              type: 'warning',
              duration: 1000
            })

            return
          }
          if (this.form[key] === '不符合要求' && !this.form[key.slice(0, 7) + 'sj']) {
            this.$notify({
              title: '未填写',
              message: '位置:' + this.form[key.slice(0, 3)] + '，项目编号：' + key.slice(3, 7) + '不符合要求需要选择隐患',
              type: 'warning',
              duration: 2000
            })
            return
          }
        }
      }
      if (this.isLoading) return;
      this.isLoading = true;
      if (this.form.hasOwnProperty("id")) {
        this.onEdit()
      } else {
        this.onAdd()
      }
      this.isLoading = false;
    },
    debouncedHandleSubmit: _.debounce(function () {
      this.handleSubmit()
    }, 3000, {leading: true, trailing: false}),
    //新增
    async onAdd() {
      try {
        let params = {
          ...this.form,
          site_id: this.site_id,
          project_id: this.project_id,
          current_page: this.currentPage,
          zg_type: this.zg_type,
          site_type: this.site_type
        }
        let res = await this.$Api.post('add_record_zg', params)
        if (res) {
          this.form.id = res.id
          await this.getWzOpts()
          this.$notify({title: '成功', message: '新增成功', type: 'success', duration: 500})
          await this.fetchMaxPage(this.currentPage + 1)
        }
      } catch (e) {
        this.$notify({title: '错误', message: e.errormsg, duration: 500})
      }
    },
    //编辑
    async onEdit() {
      try {
        let params = {
          ...this.form,
          site_id: this.site_id,
          project_id: this.project_id,
          current_page: this.currentPage,
          zg_type: this.zg_type,
          site_type: this.site_type
        }
        await this.$Api.post('edit_record_zg', params)
        this.$notify({title: '成功', message: '更新成功', type: 'success', duration: 500})
        this.getWzOpts()
      } catch (e) {
        this.$notify({title: '错误', message: e.errormsg, duration: 500})
      }
    },
    //获取当前页面的位置
    getWzOpts() {
      let keysToKeep = ['wz1', 'wz2', 'wz3', 'wz4'];
      this.wzOpts = Object.entries(this.form).filter(([key, value]) => keysToKeep.includes(key) && value !== '' && value !== null).map(([key, value]) => ({
        label: value,
        value: key
      }));
    },
    async getList() {
      try {
        let data = await this.$Api.post('index_zg_image', {
          project_id: this.project_id,
          site_id: this.site_id,
          form_page: this.currentPage,
          zg_type: this.zg_type,
          ...this.pagination
        })
        if (data) {
          this.pagination = {
            current_page: data.current_page,
            total: data.total,
            per_page: data.per_page
          }
          this.tableData = data.data;
        } else {
          this.tableData = []
          this.pagination = {current_page: 1, total: 1, per_page: 10}
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //设置操作按钮的状态
    async setButtonStatus() {
      try {
        let res = await this.$Api.post('get_site_status', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
          status_type: 'zg'
        })
        if (res) {
          if (res === '检测中' || res === '已完成') {
            this.inspect_status = true
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //快捷操作
    handleSelectCommand(value) {
      const [location, status] = value.split(' ')
      const result = status === '符合要求' ? '符合要求' : '不符合要求'
      this.setResultForLocation(result, location)
    },
    setResultForLocation(result, location) {
      Object.keys(this.form).forEach(key => {
        if (key.includes('jg') && (location === '全部' || key.includes(location))) {
          this.form[key] = result
        }
      })
    }
  },
  computed: {
    site_czw_list() {
      return site_czw_list
    }
  },
  watch: {
    currentPage() {
      this.getWzOpts()
    },
    '$route.params.zg_type'(v) {
      this.init();
    },
  },
  created() {
    this.init();
  },
}
</script>
<style scoped>
table {
  width: 100%;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  vertical-align: middle !important;
}
</style>

<style>
.hide .el-upload--picture-card {
  display: none;
}
</style>